const GUARD_KEY = "vite-preload-error-reloaded-at";
const GUARD_WINDOW_MS = 10_000;

/**
 * After a new deployment, a stale client can fail to load hashed chunks that no
 * longer exist. Vite fires "vite:preloadError" in that case — reload to pick up
 * the new bundle. A sessionStorage timestamp guards against reload loops; inside
 * the guard window the error propagates to the error boundary instead.
 */
export function setupPreloadErrorReload(reload: () => void = () => window.location.reload()) {
    const handler = (event: Event) => {
        const lastReloadAt = Number(sessionStorage.getItem(GUARD_KEY) ?? 0);
        if (Date.now() - lastReloadAt < GUARD_WINDOW_MS) return;
        sessionStorage.setItem(GUARD_KEY, String(Date.now()));
        event.preventDefault();
        reload();
    };
    window.addEventListener("vite:preloadError", handler);
    return () => window.removeEventListener("vite:preloadError", handler);
}
